<div class="container-fluid si-layout-main-padding">
  <div class="row mb-9">
    <app-vehicle class="h-100" />
  </div>
  <div class="row mb-9">
    <app-schedule-and-track />
  </div>
</div>
